import { render, staticRenderFns } from "./create-smokecrib.vue?vue&type=template&id=0a0ff91d&"
import script from "./create-smokecrib.vue?vue&type=script&lang=ts&"
export * from "./create-smokecrib.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports